// extracted by mini-css-extract-plugin
export default {"container":"RegListActionCard_container__VZgcb","section":"RegListActionCard_section__eUMu9","hidden":"RegListActionCard_hidden__LFM6C"};